query GetNotification(
  $first: Int
  $order_by: [UserNotificationsOrderBy!]
  $after: Cursor
) {
  userNotifications(first: $first, orderBy: $order_by, after: $after) {
    nodes {
      _isExtendedMessage
      extendedMessage {
        messageSections(orderBy: SEQUENCE_NUMBER_ASC) {
          nodes {
            columnAlignment1
            columnAlignment2
            columnAlignment3
            columnAlignment4
            columnAlignment5
            columnHeading1
            columnHeading2
            columnHeading3
            columnHeading4
            columnHeading5
            sectionHeader
            sectionBody
            sectionFooter
            tableColumns
            linkTitle
            linkType
            entityId
            messageTableColumns(orderBy: SORT_ORDER_ASC) {
              nodes {
                column1Value
                column2Value
                column3Value
                column4Value
                column5Value
              }
            }
          }
        }
      }
      _createdDate
      _isNewMessage
      _notificationTitle
      _receivedDate
      id
      messageComment
      linkId
      linkTitle
      notificationTypeId
      linkType
      invoiceMessage {
        _isAccountingEntry
        _isHistory
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
